import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { t } from '@kso/ui/lib/config/locale';
import KMessage from '@kso/ui/lib/utils/message';
import { clipboard } from 'vue-clipboards';
import Button from '@kdocs/kdesign-vue/lib/button';
import '@kdocs/kdesign-vue/lib/theme-chalk/button.css';

var CopyLink = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-copy-link"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.txt0))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.url))])]), _vm._v(" "), _c('kd-button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard",
        value: _vm.url,
        expression: "url"
      }],
      on: {
        "click": _vm.copySuccess,
        "success": function success($event) {
          return _vm.copySuccess();
        },
        "error": function error($event) {
          return _vm.copyError();
        }
      }
    }, [_vm._v(_vm._s(_vm.txt1))])], 1);
  },
  staticRenderFns: [],
  name: 'KCopyLink',
  components: _defineProperty({}, Button.name, Button),
  props: {
    url: {
      type: String
    }
  },
  directives: {
    clipboard: clipboard
  },
  data: function data() {
    return {
      txt0: t('logic.CopyLink.txt0'),
      txt1: t('logic.CopyLink.txt1'),
      txt2: t('logic.CopyLink.txt2'),
      txt3: t('logic.CopyLink.txt3')
    };
  },
  methods: {
    copySuccess: function copySuccess() {
      KMessage.success(this.txt2);
    },
    copyError: function copyError() {
      KMessage.success(this.txt3);
    }
  }
};

CopyLink.install = function (Vue) {
  Vue.component(CopyLink.name, CopyLink);
};

export { CopyLink as default };
